/*global angular */

(function (angular) {
'use strict';

var cauth = angular.module('cauth', [
    'infinite-scroll',
    'cauth.controllers',
    'cauth.services',
    'cauth.filters',
    'cauth.directives',
    'timeline.services'
]);

var writeReview = {verb: 5, templateUrl: '/write.review.html'},
    writeFact = {verb: 6, templateUrl: '/write.fact.html'},
    writeQuote = {verb: 7, templateUrl: '/write.quote.html'},
    writeTopic = {verb: 8, templateUrl: '/write.topic.html'},
    likeQuote = {verb: 9, templateUrl: '/like.quote.html'},
    likeTopic = {verb: 10, templateUrl: '/like.topic.html'},
    likeFact = {verb: 11, templateUrl: '/like.fact.html'},
    likeBookComment = {verb: 24, templateUrl: '/like.book.comment.html'},
    likeComment = {verb: 12, templateUrl: '/like.comment.html'},
    comment = {verb: 13, templateUrl: '/comment.html'},
    writeBookComment = {verb: 14, templateUrl: '/write.book.comment.html'},
    rateBook = {verb: 15, templateUrl: '/rate.book.html'},
    moderateBook = {verb: 16, templateUrl: '/moderate.book.html'},
    addToShelf = {verb: 17, templateUrl: '/add.to.shelf.html'},
    achieve = {verb: 18, templateUrl: '/achieve.html', blank: true},
    writeMessageToUser = {verb: 19, templateUrl: '/write.message.to.user.html'},
    follow = {verb: 20, templateUrl: '/follow.html'},
    mentionInComment = {verb: 21, templateUrl: '/mention.in.comment.html'},
    mentionInReview = {verb: 22, templateUrl: '/mention.in.review.html'},
    mentionInTopic = {verb: 23, templateUrl: '/mention.in.topic.html'},
    statusLabelAssigned = {verb: 25, templateUrl: '/statusAssigned.html'};

cauth.constant('Verbs', {
    writeReview: writeReview,
    writeFact: writeFact,
    writeQuote: writeQuote,
    writeTopic: writeTopic,
    likeQuote: likeQuote,
    likeTopic: likeTopic,
    likeFact: likeFact,
    likeBookComment: likeBookComment,
    likeComment: likeComment,
    comment: comment,
    writeBookComment: writeBookComment,
    rateBook: rateBook,
    moderateBook: moderateBook,
    addToShelf: addToShelf,
    achieve: achieve,
    writeMessageToUser: writeMessageToUser,
    follow: follow,
    mentionInComment: mentionInComment,
    mentionInReview: mentionInReview,
    mentionInTopic: mentionInTopic,
    statusLabelAssigned: statusLabelAssigned
});

cauth.constant('StatusLabelIds', {
    resident: 1,
    king: 2,
    helper: 3,
    hope: 4,
    pride: 5,
    legend: 6
});

cauth.constant('activityGroups', [
    {group: [follow.verb], templateUrl: '/group.follow.html'},
    {group: [rateBook.verb, addToShelf.verb], templateUrl: '/group.read.rate.book.html'}
]);

cauth.constant('Streams', {
    user: {id: 1, public: true},
    follow: {id: 2, public: false},
    notification: {id: 3, public: false},
    bookshelffollow: {id: 4, public: false},
    likefollow: {id: 5, public: false},
    friendfollow: {id: 6, public: false}
});
}(angular));
